var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHyvanArjenRutiinit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142 142",
    style: {
      enableBackground: "new 0 0 142 142"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#f277c6;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 71,
    cy: 71,
    r: 71
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71,117.9c-25.9,0-46.9-21.1-46.9-46.9S45.1,24.1,71,24.1s46.9,21.1,46.9,46.9S96.9,117.9,71,117.9z M71,28.5 c-23.4,0-42.5,19-42.5,42.5s19.1,42.5,42.5,42.5s42.5-19,42.5-42.5S94.4,28.5,71,28.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "73.2,73.2 49.4,73.2 49.4,68.8 68.8,68.8 68.8,39.4 73.2,39.4  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyvanArjenRutiinit);
export default __webpack_public_path__ + "static/media/hyvan-arjen-rutiinit.51277a9f8d7079033adf51f54e15b4e6.svg";
export { ForwardRef as ReactComponent };